export default __webpack_public_path__ + "static/media/D_Home_O.eec35007.jpg";